import * as React from "react";
import "./followList.css";
import "../../style/fonts.css";
import { connect } from "react-redux";
import { getVal, firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import FollowedUser from "./followedUser";

export interface Props {
  followList: any;
}

class FollowList extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    if (this.props.followList) {
      return (
        <div className="FOLLOW_LIST_CONT">
          {this.props.followList.map((user, idx) => {
            return <FollowedUser key={user.uid + idx} user={user} />;
          })}
        </div>
      );
    } else return null;
  }
}

export default FollowList;



// WEBPACK FOOTER //
// ./src/components/followList/followList.tsx